import { firebaseApp } from "./Config";
import { doc, getFirestore, deleteDoc } from "firebase/firestore";

export const DeleteDocument = async (documentId: string) => {
	const db = getFirestore(firebaseApp);
	return await deleteDoc(doc(db, "documents", documentId));
};
